import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import {
    Typography,
    DialogContent,
    FormControl,
    RadioGroup,
    Radio,
    SvgIcon,
} from '@mui/material';

// Asset import
import { ReactComponent as FilterAltOutlined } from '~/assets/icons/filter_alt_outlined.svg';
import { ReactComponent as FilterAlt } from '~/assets/icons/filter_alt.svg';

// Util import
import { FABULA, FARM, FARM_ETC, FOXTON, getBrandNameFromBrandId } from '~/util/brands';

// Style import
import * as Style from '../styles';
import { VENDEDOR_ADOROCODIGO } from '~/util/perfilId';

function TreinadoraAdoroCodigoBrandFilter({ brandFilter, setBrandFilter }) {
    const userProfile = useSelector(state => state.user.profile);
    const location = useLocation().search;
    const trainerAffiliateView = location.includes('salesCode');
    const [brandFilterDialogIsOpen, setBrandFilterDialogIsOpen] = useState(false);

    if (trainerAffiliateView) {
        return null;
    }

    const handleClickOnRadioButton = event => {
        setBrandFilter(event.target.value);
        setBrandFilterDialogIsOpen(false);
    };

    return (
        <>
            <Style.DialogContainer
                onClose={() => setBrandFilterDialogIsOpen(false)}
                open={brandFilterDialogIsOpen}
            >
                <Style.BrandFilterTitleContainer container>
                    <SvgIcon
                        style={{
                            fill: '#DCC6B7',
                            verticalAlign: 'text-bottom',
                        }}
                        component={FilterAltOutlined}
                    />
                    <Typography display="inline">Exibir Somente</Typography>
                </Style.BrandFilterTitleContainer>
                <DialogContent>
                    <FormControl component="fieldset">
                        <RadioGroup
                            value={brandFilter}
                            onChange={e => handleClickOnRadioButton(e)}
                        >
                            <Style.BrandsFormControlLabel
                                value="allBrands"
                                control={
                                    <Radio
                                        sx={{
                                            color: '#DCC6B7',
                                            '&.Mui-checked': {
                                                color: '#DCC6B7',
                                            },
                                        }}
                                    />
                                }
                                label="Todos os pedidos"
                            />

                            <>
                                {userProfile.id_perfil === VENDEDOR_ADOROCODIGO ? (
                                    [FARM, FARM_ETC].map(brand => (
                                        <Style.BrandsFormControlLabel
                                            key={brand}
                                            value={`${getBrandNameFromBrandId(brand)}`}
                                            control={
                                                <Radio
                                                    sx={{
                                                        color: '#DCC6B7',
                                                        '&.Mui-checked': {
                                                            color: '#DCC6B7',
                                                        },
                                                    }}
                                                />
                                            }
                                            label={`Pedidos na ${getBrandNameFromBrandId(
                                                brand
                                            )}`}
                                        />
                                    ))
                                ) : (
                                    [FARM, FABULA, FOXTON, FARM_ETC].map(brand => (
                                        <Style.BrandsFormControlLabel
                                            key={brand}
                                            value={`${getBrandNameFromBrandId(brand)}`}
                                            control={
                                                <Radio
                                                    sx={{
                                                        color: '#DCC6B7',
                                                        '&.Mui-checked': {
                                                            color: '#DCC6B7',
                                                        },
                                                    }}
                                                />
                                            }
                                            label={`Pedidos na ${getBrandNameFromBrandId(
                                                brand
                                            )}`}
                                        />
                                    ))
                                )}
                            </>

                            {userProfile.id_perfil !== VENDEDOR_ADOROCODIGO && (
                                <Style.BrandsFormControlLabel
                                    value="farmLatam"
                                    control={
                                        <Radio
                                            sx={{
                                                color: '#DCC6B7',
                                                '&.Mui-checked': {
                                                    color: '#DCC6B7',
                                                },
                                            }}
                                        />
                                    }
                                    label="Pedidos na Farm LATAM"
                                />
                            )}
                        </RadioGroup>
                    </FormControl>
                </DialogContent>
            </Style.DialogContainer>
            <Style.BrandFilterTextContainer
                item
                container
                onClick={() => {
                    setBrandFilterDialogIsOpen(true);
                }}
            >
                <SvgIcon
                    style={{
                        fill: '#DCC6B7',
                        verticalAlign: 'text-bottom',
                    }}
                    component={
                        brandFilter === 'allBrands'
                            ? FilterAltOutlined
                            : FilterAlt
                    }
                />
                <Style.BrandFilterTextType>Filtrar</Style.BrandFilterTextType>
            </Style.BrandFilterTextContainer>
        </>
    );
}

export default TreinadoraAdoroCodigoBrandFilter;
